export const isDevelop = process.env.NODE_ENV === 'development';
export const isTest = process.env.NODE_ENV === 'test';
